import script from "./MyBarChart.vue?vue&type=script&setup=true&lang=js"
export * from "./MyBarChart.vue?vue&type=script&setup=true&lang=js"

import "./MyBarChart.vue?vue&type=style&index=0&id=5780530f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5780530f"]])

export default __exports__